// ------------------------------------
// props 輸入需求 :
// props.isON : boolean                                   ( 元件開關 )
// props.setReturnState : function( params : str )        ( 回傳 : str ('level 1', 'level 2', 'level 3') )
// ------------------------------------


import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import Account from '../../../../actions/Account';

const AlertState =(props)=>{
    const { t } = useTranslation(); // 1.2 i18n

    // 三班 選到的回傳值 : shiftSelected (mid/ morn / night)
    const [stateOpen, setStateOpen] = useState();
    function toggleStateOpen(){ setStateOpen(!stateOpen) }
    const [stateSelected, setStateSelected] = useState('all');
    const shift_show = ((stateSelected==="all")? t('GLOBAL.BED_STATE.ALL'):(stateSelected==="normal")? t('GLOBAL.BED_STATE.LEVEL1'):((stateSelected==="warning")?t('GLOBAL.BED_STATE.LEVEL2'):t('GLOBAL.BED_STATE.LEVEL3')))
    function clickState(e){
        setStateSelected(e.target.id)
        props.setReturnState(e.target.id)
    }
    if(Account.isMobileOrTablet()){
        return(
            <div className={`${Account.isMobile()?"littleUi":"col-2"} fx-ccc`}>
                {props.isON?
                    <div className="top-tag fx-d-c mar-l">
                        <div className="name m fx-ccc">{t("HISTORY_RECORD.ALERT")}</div>
                        <div className="fx-ccc h-50">
                            <div className="inner st" onClick={toggleStateOpen}>{shift_show}</div>
                            {stateOpen && (
                                <div className="pos-f z-max wid-full hig-full top-0 left-0 cursor-def" onClick={toggleStateOpen}>
                                    <div className="pos-a state m">
                                        <div id="all" className="individual" onClick={clickState}>{t('GLOBAL.BED_STATE.ALL')}</div>
                                        <div id="normal" className="individual" onClick={clickState}>{t('GLOBAL.BED_STATE.LEVEL1')}</div>
                                        <div id="warning" className="individual" onClick={clickState}>{t('GLOBAL.BED_STATE.LEVEL2')}</div>
                                        <div id="emergency" className="individual" onClick={clickState}>{t('GLOBAL.BED_STATE.LEVEL3')}</div>
                                    </div>
                                </div>
                                )}
                        </div>
                    </div>
                :null}
            </div>
        );
    }
    else{
        return(
            <div className="col-4 fx-ccc ">
                {props.isON?
                    <div className="top-tag fx-d-r mar-l">
                        <div className="name fx-ccc">{t("HISTORY_RECORD.ALERT")}</div>
                        <div className="body h-50">
                            <div className="inner st" onClick={toggleStateOpen}>{shift_show}</div>
                            {stateOpen && (
                                <div className="pos-f z-max wid-full hig-full top-0 left-0 cursor-def" onClick={toggleStateOpen}>
                                    <div className="pos-a state">
                                        <div id="all" className="individual" onClick={clickState}>{t('GLOBAL.BED_STATE.ALL')}</div>
                                        <div id="normal" className="individual" onClick={clickState}>{t('GLOBAL.BED_STATE.LEVEL1')}</div>
                                        <div id="warning" className="individual" onClick={clickState}>{t('GLOBAL.BED_STATE.LEVEL2')}</div>
                                        <div id="emergency" className="individual" onClick={clickState}>{t('GLOBAL.BED_STATE.LEVEL3')}</div>
                                    </div>
                                </div>
                                )}
                        </div>
                    </div>
                :null}
            </div>
        );
    }
}
export default AlertState;